<template>
	<div id="personalXg">
		<div class="personalaccount_content">
			<div class="personalaccount_content_left">
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						个人资料
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box ">
							<router-link to="/personalaccount">基本信息</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalAddress" class="">收货地址</router-link>

						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						安全设置
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box select_box">
							<router-link to="/personalXg" class="select_box">修改密码</router-link>

						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalPhone" class="">手机绑定</router-link>

						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						账号绑定
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalWechart">微信绑定</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalEmail" class="">邮箱绑定</router-link>
						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item" v-if="sign == 1 || sign == 2">
					<div class="personalaccount_content_left_item_head">
						集团账号管理
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box" v-if="sign == 1">
							<router-link to="/personalCgr" class="">采购员管理</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalProcurement">采购订单</router-link>

						</div>
					</div>
				</div>
			</div>
			<div class="personalaccount_content_right">
				<div class="personalaccount_content_right_head">
					<div class="personalaccount_content_right_head_left">
						身份验证
					</div>
					<div class="personalaccount_content_right_head_right">
						<!--<img src="../../../assets/img/personalhome/tishi-jinggao-tianseban.png"/>
						我们不会泄露您的手机信息-->
					</div>
				</div>

				<div class="personalaccount_content_right_content">
					<div class="personalaccount_content_right_content_item">
						<span class="personalaccount_content_right_content_item_txt">手机号码：</span>
						<span class="personalaccount_content_right_content_item_txt1">{{phone}}</span>
						<span class="personalaccount_content_right_content_item_txt2"></span>
					</div>
					<div class="personalaccount_content_right_content_item">
						<span class="personalaccount_content_right_content_item_txt">人机验证：</span>
						<div class="personalaccount_content_right_content_item_validate">
							<validate @success="SetToken" class=""></validate>
						</div>
					</div>
					<div class="personalaccount_content_right_content_item">
						<span class="personalaccount_content_right_content_item_txt">验证码：</span>
						<input @input="inputFn" class="personalaccount_content_right_content_item_inp" type="" name="" id="code" value="" />
						<!--<span class="personalaccount_content_right_content_item_btn">免费获取</span>-->
						<span class="personalaccount_content_right_content_item_btn" @click="yanzhengFn" v-if="countDownSecondBool == true">{{countDownSecond}}</span>
						<span class="personalaccount_content_right_content_item_btn1" v-else>{{countDownSecond}}</span>
					</div>
					<div class="personalaccount_content_right_content_item">
						<span class="personalaccount_content_right_content_item_txt">新登录密码：</span>
						<input @input="inputFn" class="personalaccount_content_right_content_item_inp1" type="" name="" id="password" value="" />
						<!--<span class="personalaccount_content_right_content_item_btn">免费获取</span>-->
					</div>
					<div class="personalaccount_content_right_content_item">
						<span class="personalaccount_content_right_content_item_txt">确认新的登录密码：</span>
						<input @input="inputFn" class="personalaccount_content_right_content_item_inp1" type="" name="" id="repassword" value="" />
						<!--<span class="personalaccount_content_right_content_item_btn">免费获取</span>-->
					</div>
					<div class="personalaccount_content_right_content_btn" @click="registerFn">
						确定
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import DateSelect from '@/components/DateSelect'
	import Validate from '@/components/NC'
	import qs from 'qs'
	export default {
		name: 'personalXg',

		components: {
			DateSelect,
			Validate,
		},
		data() {
			return {
				fixedkey: false,
				zhqiehuan: false,
				localData: {}, //注册所需数据存储
				checkedValue: '', //注册用户身份
				checkedValue_z: false, //注册用户协议
				countDownSecond: '获取验证码', //验证码
				countDownSecondBool: true, //判断验证码是否发送,
				mobile_phoneData: {}, //获取验证码时所需的值
				phone: '',
				sign: '',
				resp_: '',

			}
		},
		created() {
			let that = this;
			if(that.$storage.get('user_data') != null) {
				console.log(that.$storage.get('user_data'))
				that.phone = that.$storage.get('user_data').mobile_phone
				that.mobile_phoneData['mobile_phone'] = that.phone;
				that.sign = that.$storage.get('user_data').sign
			} else {

			}

		},
		mounted() {

			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				console.log()
				if(scrollTop >= 300) {
					this.fixedkey = true
				} else {
					this.fixedkey = false

				}
			},
			dateChange(obj) {
				console.log(obj.year + '-' + obj.month + '-' + obj.day);
			},
			//获取值
			inputFn(event) {
				let that = this;
				that.localData[event.currentTarget.id] = event.currentTarget.value;
				if(event.currentTarget.id == 'mobile_phone') {
					that.mobile_phoneData[event.currentTarget.id] = event.currentTarget.value
				}

			},
			//注册方法
			registerFn() {
				let that = this;
				that.localData['mobile_phone'] = that.phone
				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.editpsw,
						data: qs.stringify(that.localData),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;

						if(data.stateCode == 10000) {

							that.$router.go(0)
						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			SetToken(resp) {
				let that = this;
				that.resp_ = resp;
				that.mobile_phoneData['luotest_response'] = that.resp_;
				that.mobile_phoneData['lvt'] = 'pc';

			},
			//验证码方法
			yanzhengFn() {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.logingetCodeInfo,
						data: qs.stringify(that.mobile_phoneData),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							that.$message({
								message: data.msg,
								type: 'success'
							});
							that.daojishiFn();
						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//倒计时方法
			daojishiFn() {
				let that = this;
				var sec = 60;
				that.countDownSecondBool = false;
				var interval = setInterval(function() {

					var secStr = sec.toString();
					if(secStr.length == 1) secStr = '0' + secStr;
					that.countDownSecond = secStr + 's后失效';
					//					console.log(that.countDownSecond)
					sec--;

					if(sec < 0) {
						clearInterval(interval);
						that.countDownSecond = '获取验证码';
						that.countDownSecondBool = true;

					}
				}.bind(that), 1000);
			},

		},

	}
</script>

<style scoped="scoped">
	#personalXg {
		width: 100%;
		background-color: #f6f6f6;
		padding-top: 20px;
		padding-bottom: 20px;
	}
	
	.personalaccount_content {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: nowrap;
		align-items: self-start;
	}
	
	.personalaccount_content_left {
		width: 170px;
		text-align: center;
		background: #ffffff;
	}
	
	.personalaccount_content_left_item_head {
		width: 100%;
		height: 50px;
		line-height: 50px;
		background: #dddddd;
		color: #333333;
		font-size: 18px;
		font-weight: 550;
	}
	
	.personalaccount_content_left_item_content {
		width: 100%;
	}
	
	.personalaccount_content_left_item_content_box {
		font-size: 16px;
		color: #333333;
		width: 100%;
		height: 40px;
		margin-top: 10px;
		line-height: 40px;
	}
	
	.select_box {
		background: #DC1E33;
		color: #ffffff;
	}
	
	.personalaccount_content_left_item_content_box span {
		color: #DC1E33;
	}
	
	.personalaccount_content_right {
		width: 1010px;
		margin-left: 20px;
		background: #ffffff;
	}
	
	.personalaccount_content_right_head {
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		width: 100%;
		background: #fe818d;
		color: #ffffff;
		font-size: 18px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	
	.personalaccount_content_right_content_item_validate {
		display: inline-block;
		width: calc(100% - 100px);
		box-sizing: border-box;
		/*padding-left: 20px;*/
		font-size: 16px;
		color: #666666;
		border-radius: 5px;
	}
	
	.personalaccount_content_right_content {
		width: 552px;
		margin: 0 auto;
		margin-top: 40px;
	}
	
	.personalaccount_content_right_content_item {
		width: 100%;
		margin-top: 30px;
		/*position: relative;*/
		display: flex;
		flex-wrap: nowrap;
	}
	
	.personalaccount_content_right_content_item_txt {
		width: 190px;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		color: #333333;
		font-size: 18px;
		text-align: right;
	}
	
	input {
		outline: none;
		border: 0;
	}
	
	.personalaccount_content_right_content_item_inp {
		border: 1px solid #dddddd;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		width: calc(100% - 220px);
		box-sizing: border-box;
		padding-left: 20px;
		font-size: 16px;
		color: #666666;
		border-radius: 5px;
	}
	
	.personalaccount_content_right_content_item_inp1 {
		border: 1px solid #dddddd;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		width: calc(100% - 120px);
		box-sizing: border-box;
		padding-left: 20px;
		font-size: 16px;
		color: #666666;
		border-radius: 5px;
	}
	
	.personalaccount_content_right_content_item_txt1 {
		/*border: 1px solid #dddddd;*/
		display: inline-block;
		height: 40px;
		line-height: 40px;
		width: calc(100% - 220px);
		box-sizing: border-box;
		/*padding-left: 20px;*/
		font-size: 16px;
		color: #666666;
		border-radius: 5px;
	}
	
	.personalaccount_content_right_content_item_txt2 {
		width: 100px;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		color: #333333;
		font-size: 18px;
		margin-left: 20px;
	}
	
	.personalaccount_content_right_content_item_btn {
		width: 120px;
		display: inline-block;
		text-align: center;
		height: 40px;
		line-height: 40px;
		color: #ffffff;
		background: #DC1E33;
		border-radius: 0 5px 5px 0;
		font-size: 18px;
		cursor: pointer;
	}
	
	.personalaccount_content_right_content_item_btn1 {
		width: 120px;
		display: inline-block;
		text-align: center;
		height: 40px;
		line-height: 40px;
		color: #333333;
		background: #dddddd;
		border-radius: 0 5px 5px 0;
		font-size: 18px;
		cursor: pointer;
	}
	
	.personalPhone_footer {
		width: 100%;
		box-sizing: border-box;
		padding-left: 100px;
	}
	
	.personalPhone_footer_head {
		font-size: 18px;
		color: #333333;
		margin-bottom: 20px;
	}
	
	.personalPhone_footer_txt {
		font-size: 16px;
		color: #666666;
		margin-bottom: 8px;
	}
	
	.personalaccount_content_right_content_btn {
		width: 160px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		margin: 60px auto;
		color: #FFFFFF;
		font-size: 24px;
		background: #DC1E33;
		border-radius: 5px;
		cursor: pointer;
	}
	
	.personalaccount_content_right_content_item_lable {
		line-height: 30px;
		width: 100px;
		position: relative;
	}
	
	.personalaccount_content_right_content_item_lable span {
		display: inline-block;
		font-size: 16px;
		color: #333333;
		margin-left: 20px;
		line-height: 40px;
	}
	
	input[type="radio"] {
		width: 20px;
		height: 20px;
		opacity: 0;
		position: relative;
		top: 4px;
		left: 5px;
	}
	
	label {
		position: absolute;
		left: 5px;
		top: 9px;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 1px solid #666666;
		display: inline-block;
	}
	/*设置选中的input的样式*/
	/* + 是兄弟选择器,获取选中后的label元素*/
	
	input:checked+label {
		background-color: #DC1E33;
		border: 1px solid #DC1E33;
	}
	
	input:checked+label::after {
		position: absolute;
		content: "";
		width: 5px;
		height: 10px;
		top: 3px;
		left: 6px;
		border: 2px solid #fff;
		border-top: none;
		border-left: none;
		transform: rotate(45deg)
	}
</style>